import { render, staticRenderFns } from "./DispositionPicker.vue?vue&type=template&id=874d09be&scoped=true&"
import script from "./DispositionPicker.vue?vue&type=script&lang=ts&"
export * from "./DispositionPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874d09be",
  null
  
)

export default component.exports